import { render, staticRenderFns } from "./hooyu.vue?vue&type=template&id=421c603b&scoped=true"
import script from "./hooyu.vue?vue&type=script&lang=js"
export * from "./hooyu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421c603b",
  null
  
)

export default component.exports